var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCardPrescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.608 14.98c.502 0 .91-.406.91-.907a.908.908 0 0 0-.91-.906H6.429a.908.908 0 0 0-.91.906c0 .501.408.906.91.906h6.179Zm0-6.423H6.429a.908.908 0 0 0-.91.907c0 .5.408.906.91.906h6.179c.502 0 .91-.405.91-.906a.908.908 0 0 0-.91-.907Zm5.554 9.318V4.125c0-1.793-1.466-3.25-3.267-3.25H4.142C2.34.875.875 2.332.875 4.125v13.75c0 1.793 1.466 3.25 3.267 3.25h10.753c1.801 0 3.267-1.457 3.267-3.25ZM8 3.948a.66.66 0 0 1-.66-.656v-.604h4.357v.604a.66.66 0 0 1-.66.656H8Zm6.895-1.26c.798 0 1.446.645 1.446 1.437v13.75c0 .792-.648 1.438-1.446 1.438H4.142a1.443 1.443 0 0 1-1.446-1.438V4.125c0-.792.648-1.438 1.446-1.438h1.377v.605A2.478 2.478 0 0 0 8 5.76h3.037a2.478 2.478 0 0 0 2.481-2.468v-.604h1.377Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCardPrescription);
export default __webpack_public_path__ + "static/media/icon_chat_card_prescription.0974f6bd4387091cedd29e24055de4f0.svg";
export { ForwardRef as ReactComponent };